import {VendorMinInf} from '../../interfaces/common'
import {AdjustCfg} from './img.editor.iface'

const IMG_EDITOR = {
  getDefaultCfg: (): AdjustCfg => {
    return {
      source: null,
      imageId: null,
      adjustedSrc: null,
      skipped: false,
      originSize: {
        x: null,
        y: null
      },
      outputSize: {
        x: null,
        y: null
      }
    }
  }
}
export const WIZARD_CFG = {
  types: {
    cover: {
      title: 'Main Cover Image',
      details: 'Display everything',
      description: 'Chose Image for the Cover with minimal width 1000px and set cropping-borders manually',
      minWidth: 720,
      minUploadWidth: 640,
      ratio: '4:3',
      tag: 'cover',
      baseTag: 'cover',
      imageExists: false,
      // isFinished: false,
      canSkip: false,
      config: IMG_EDITOR.getDefaultCfg()
    },
    'cover-ads': {
      title: 'Advertising Image',
      details: 'Display in Advertising',
      description: 'Chose Image for the Cover Advertising and set cropping-borders manually',
      minWidth: 350,
      minUploadWidth: 300,
      ratio: '1:1',
      tag: 'cover-ads',
      baseTag: 'cover',
      imageExists: false,
      // isFinished: false,
      canSkip: true,
      config: IMG_EDITOR.getDefaultCfg()
    },
    'cover-stripe': {
      title: 'Stripe Image',
      details: 'Image for Website',
      description: 'Chose Image for Cover with minimal width 2000px and set borders manually',
      minWidth: 2000,
      minUploadWidth: 1600,
      ratio: '24:5',
      tag: 'cover-stripe',
      baseTag: 'cover',
      imageExists: false,
      // isFinished: false,
      canSkip: true,
      config: IMG_EDITOR.getDefaultCfg()
    },
    seat_map: {
      title: 'Seat Map Image',
      details: '',
      description: 'Chose Image for the Seat Map with minimal width 1000px and set cropping-borders manually',
      minWidth: 1000,
      minUploadWidth: 720,
      ratio: '4:3',
      tag: 'seat_map',
      baseTag: 'seat_map',
      imageExists: false,
      // isFinished: false,
      canSkip: true,
      config: IMG_EDITOR.getDefaultCfg()
    },
    'gallery-big': {
      title: 'Gallery Image',
      details: '',
      description: 'Chose Image for the Gallery with minimal width 1400px and set cropping-borders manually',
      minWidth: 1400,
      minUploadWidth: 1000,
      ratio: '4:3',
      tag: 'gallery-big',
      baseTag: 'gallery',
      imageExists: false,
      // isFinished: false,
      canSkip: false,
      config: IMG_EDITOR.getDefaultCfg()
    },
    'gallery-thumb': {
      title: 'Gallery Thumbnail',
      details: '',
      description: 'Chose Image for Gallery with minimal width 1400px and set borders manually',
      minWidth: 360,
      minUploadWidth: 300,
      ratio: '4:3',
      tag: 'gallery-thumb',
      baseTag: 'gallery',
      imageExists: false,
      canSkip: false,
      // isFinished: false,
      config: IMG_EDITOR.getDefaultCfg()
    }
  }
}
